'use strict';

/* globals $, TMPlus, window, app */

(function () {
	const Creator = {};

	function init() {
		$(window).on('action:composer.enhanced', initComposer);
	}

	function initComposer() {
		require(
			['composer', 'composer/formatting', 'composer/controls', 'tmpsession-creator'],
			(composer, formatting, controls, creator) => {
				// console.log({ composer, formatting, controls, creator });
				if (formatting && controls) {
					formatting.addButtonDispatch('tmplus', (textarea) => {
						composerBtnHandle(composer, textarea, creator)
							.then()
							.catch(err => console.error(err));
					});
				}
			}
		);
	}

	async function composerBtnHandle(composer, textarea, creator) {
		const post = composer.posts[composer.active];
		if (!post || !post.isMain || (isNaN(parseInt(post.cid, 10)) && isNaN(parseInt(post.pid, 10)))) {
			return app.alertError('TM+ Session can only be created in main post');
		}

		const { cid, pid } = post;
		const canCreate = await TMPlus.sockets.canCreate({ pid, cid });
		if (!canCreate) { return app.alertError('No permission'); }

		creator.render({
			callback: (room) => {
				// Remove previous markups
				textarea.value = TMPlus.serializer.removeMarkup(textarea.value);
				textarea.value += `\n${TMPlus.serializer.deserialize({ sessionOptions: room })}`;
			},
		});
	}

	if (typeof TMPlus !== 'undefined') {
		init();
		TMPlus.creator = Creator;
	}
}());
